import redirectToGeneral from './redirectToGeneral';

const leaveSSA = ({ returnAfterLogin = false } = {}) => {
  if (localStorage) {
    localStorage.clear();
  }
  redirectToGeneral({ returnAfterLogin });
};

export default leaveSSA;
